// extracted by mini-css-extract-plugin
export default {"ruleCard":"rulesCard_ruleCard__bNfwj","custom-tooltip":"rulesCard_custom-tooltip__xtPeO"};